import { Button, makeStyles, TextField } from 'beam'
import Autocomplete from 'beam/dist/next/Autocomplete'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Row } from './Row'
import { TenantSummary } from './loginApi'
import { SubmissionValueDisplay } from './SubmissionValueDisplay'

const useStyles = makeStyles({
  tenantInputRootOverride: {
    marginTop: 0,
  },
})

export interface TenantResolutionProps {
  email: string,
  tenants: TenantSummary[],
  onCancel: () => void,
  onSubmit: (tenant: TenantSummary) => void,
}

export function TenantResolution({ email, tenants, onCancel, onSubmit }: TenantResolutionProps): ReactElement {
  const [selectedTenant, setSelectedTenant] = useState<TenantSummary | null>(null)
  const classes = useStyles()
  const { t } = useTranslation()
  return <form>
    <Row>
      <SubmissionValueDisplay name={t('email')}>{email}</SubmissionValueDisplay>
    </Row>
    <Row>
      <Autocomplete
        options={tenants}
        value={selectedTenant}
        onChange={(e, tenant) => setSelectedTenant(tenant)}
        getOptionLabel={(tenant: TenantSummary) => tenant.name}
        renderInput={inputProps => (
          <TextField
            {...inputProps}
            variant="outlined"
            label={t('loginTo')}
            classes={{ root: classes.tenantInputRootOverride }}
            fullWidth
          />
        )}
      />
    </Row>
    <Row>
      <Button type="submit" variant="contained" color="secondary" disabled={!selectedTenant} onClick={() => selectedTenant && onSubmit(selectedTenant)} data-testid="TenantResolution-LoginButton">
        {t('next')}
      </Button>
      <Button variant="text" onClick={onCancel} data-testid="TenantResolution-CancelButton">
        {t('cancel')}
      </Button>
    </Row>
  </form>
}
